import { LocalTransformComponent, Quaternion, Transform, TransformUtils, Vector } from '@inter-ikea-core/core';
import AnimationCallbackComponent from '../components/AnimationCallbackComponent';
import AnimationComponent from '../components/AnimationComponent';
import { PlannerEcsSystem } from './System';
export class AnimationSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'AnimationSystem', AnimationComponent.id);
        this.easeOut = (x) => {
            return Math.pow(1 - x, 4);
        };
    }
    onAdd(entity, newComponent) {
        this.animate(entity, newComponent);
        entity.removeComponent(AnimationComponent.id);
    }
    onUpdate() { }
    onRemove() { }
    notify(entity) {
        entity.addComponent(new AnimationCallbackComponent());
        entity.removeComponent(AnimationCallbackComponent.id);
    }
    isFinished(entity, component) {
        const current = TransformUtils.localTransform(entity).rotation;
        const end = component.to.rotation;
        const dist = current.toEulerDegrees().distanceTo(end.toEulerDegrees());
        return dist < 0.001;
    }
    animate(entity, component) {
        const shouldAnimate = this.coreApi
            .getServices()
            .sceneManager.entities.some(e => e.getComponent(AnimationComponent.id)?.isAnimating) || component.isAnimating;
        if (!shouldAnimate) {
            return;
        }
        else {
            requestAnimationFrame(() => this.animate(entity, component));
        }
        this.animateEntity(entity, component);
    }
    animateEntity(entity, component) {
        const { from, to, startTime, endTime } = component;
        const t = Date.now();
        const step = this.easeOut((endTime - t) / (endTime - startTime));
        if (this.isFinished(entity, component)) {
            component.isAnimating = false;
            this.notify(entity);
            return;
        }
        entity.addComponent(new LocalTransformComponent(this.lerpTransform(from, to, step)));
    }
    lerp(value1, value2, amount) {
        amount = Math.min(amount, 1);
        amount = Math.max(amount, 0);
        return value1 + (value2 - value1) * amount;
    }
    lerpVector(v1, v2, amount) {
        return new Vector(this.lerp(v1.X, v2.X, amount), this.lerp(v1.Y, v2.Y, amount), this.lerp(v1.Z, v2.Z, amount));
    }
    lerpQuaternion(q1, v2, amount) {
        return Quaternion.fromCoefficients(this.lerp(q1.w, v2.w, amount), this.lerp(q1.x, v2.x, amount), this.lerp(q1.y, v2.y, amount), this.lerp(q1.z, v2.z, amount));
    }
    lerpTransform(t1, t2, amount) {
        return new Transform(this.lerpVector(t1.position, t2.position, amount), this.lerpQuaternion(t1.rotation, t2.rotation, amount));
    }
}
//# sourceMappingURL=AnimationSystem.js.map